import { useEffect } from "react";
import fonblue from "./assets/chatgpt.png";
import MainActivity from "./page/MainActivity";
import "./App.css";
import "./css/style.css";
import MapWithParticles from "./page/Mapwithpracticles";

function App() {
  return (
    <div className="App">
      <MapWithParticles />
      <MainActivity />
    </div>
  );
}
export default App;
